import { toRefs, inject, computed } from 'vue';

//
var script = {
  name: 'CardTitle',
  props: {
    /** `left` | `right` | `center` */
    align: String
  },
  setup(props) {
    const {
      align: alignProp
    } = toRefs(props);
    const cardAlign = inject('cardAlign');
    const styles = computed(() => {
      let align;
      switch (alignProp.value || cardAlign.value) {
        case 'left':
          align = 'flex-start';
          break;
        case 'right':
          align = 'flex-end';
          break;
        default:
          align = 'center';
          break;
      }
      return {
        '--c-align': align
      };
    });
    return {
      styles
    };
  }
};
export { script as default };